import { useEffect, useRef } from "react";
import { LOGIN_URL_GOOGLE } from "../../constants/index.js";
import { loadGoogleScript } from "./scripts.js";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function GoogleLoginButton({ onLoginSuccess }) {
    const buttonRef = useRef(null);
    const renderedRef = useRef(false);

    useEffect(() => {
        let cancelled = false;

        async function initGoogle() {
            try {
                await loadGoogleScript();

                if (cancelled || !buttonRef.current || renderedRef.current)
                    return;

                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: async (response) => {
                        // response.credential is a JWT ID token
                        const idToken = response.credential;
                        const credentials = {
                            token: idToken,
                            userAgent: navigator.userAgent,
                        };

                        const res = await fetch(LOGIN_URL_GOOGLE, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(credentials),
                        });

                        if (!res.ok) {
                            throw new Error("Google login failed");
                        }

                        const user = await res.json();
                        onLoginSuccess(user);
                    },
                });

                buttonRef.current.innerHTML = "";

                window.google.accounts.id.renderButton(buttonRef.current, {
                    type: "standard",
                    theme: "filled_blue", // "outline",
                    size: "large",
                    shape: "rectangular",
                    text: "signin_with",
                    width: 280,
                });

                renderedRef.current = true;
            } catch (err) {
                console.log("Failed to load Google Sign-In script", err);
            }
        }

        initGoogle();

        return () => {
            cancelled = true;
        };
    }, [onLoginSuccess]);

    return (
        <div id="googleSignInDiv">
            <div ref={buttonRef} />
        </div>
    );
}
